<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Авторизация</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<section class="my-account py-40">
			<div class="container-fluid">
				<div class="row row-gap-4">
					<div class="col-xl-6 offset-xl-3">
						<div class="account account-1">
							<form @submit.prevent="onLoginSubmit" class="contact-form">
								<div class="row">
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="email" name="mail" autocomplete="off" class="form-control" placeholder="Ваш Email" v-model="email" required>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M18.2422 2.96875H1.75781C0.786602 2.96875 0 3.76023 0 4.72656V15.2734C0 16.2455 0.792383 17.0312 1.75781 17.0312H18.2422C19.2053 17.0312 20 16.2488 20 15.2734V4.72656C20 3.76195 19.2165 2.96875 18.2422 2.96875ZM17.996 4.14062C17.6369 4.49785 11.4564 10.6458 11.243 10.8581C10.9109 11.1901 10.4695 11.3729 10 11.3729C9.53047 11.3729 9.08906 11.1901 8.75594 10.857C8.61242 10.7142 2.50012 4.63414 2.00398 4.14062H17.996ZM1.17188 15.0349V4.96582L6.23586 10.0031L1.17188 15.0349ZM2.00473 15.8594L7.06672 10.8296L7.9284 11.6867C8.48176 12.2401 9.21746 12.5448 10 12.5448C10.7825 12.5448 11.5182 12.2401 12.0705 11.6878L12.9333 10.8296L17.9953 15.8594H2.00473ZM18.8281 15.0349L13.7641 10.0031L18.8281 4.96582V15.0349Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="password" name="password" autocomplete="off" class="form-control" placeholder="Пароль" v-model="password" required>
											<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" /></svg>
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="cus-btn-3" :disabled="btnLoginDisabled">Войти</button>
									</div>
									<div class="col-md-6 text-end">
										<router-link :to="{path: '/register'}" class="cus-btn-2">Регистрация</router-link>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		email: '',
		password: '',
		
		btnLoginDisabled: false,
		error: '',
	}),
	methods: {
		async onLoginSubmit(){
			this.error = '';
			this.btnLoginDisabled = true;
			
			const res = await this.authModel.doLogin(this.email, this.password);
			
			this.btnLoginDisabled = false;
			if(res.success){
				this.$router.push('/');
			} else {
				this.error = res.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits
	},
};
</script>